import React from "react";
import SubmittedAgreement from "../sumitted_agreement/SubmittedAgreement";

const AmendmentAgreementApplication = () => {
  const fileStatus = 21;
  const applicationPath = {
    copyright: "/admin/amendment-application-copyright",
    agreement: "/admin/amendment-application-agreement",
  };
  const detailsRoute = "/admin/letter-of-correction-agreement-details";
  const pageTitle = "সংশোধনের নথি";
  return (
    <SubmittedAgreement
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default AmendmentAgreementApplication;
